// extracted by mini-css-extract-plugin
export default {"login_wrap":"loginform_login_wrap__ZfyxC","main_div":"loginform_main_div__VIpXl","text_box":"loginform_text_box__jWmsK"};